// Cache Event Manager for cross-component communication
class CacheEventManager {
    private listeners: Set<() => void> = new Set();

    // Subscribe to cache clear events
    subscribe(callback: () => void): () => void {
        this.listeners.add(callback);

        // Return unsubscribe function
        return () => {
            this.listeners.delete(callback);
        };
    }

    // Emit cache clear event to all subscribers
    emitCacheCleared(): void {
        this.listeners.forEach(callback => {
            try {
                callback();
            } catch (error) {
                console.error('Error in cache clear listener:', error);
            }
        });
    }

    // Clear all listeners (useful for cleanup)
    clearAllListeners(): void {
        this.listeners.clear();
    }
}

// Export singleton instance
export const cacheEventManager = new CacheEventManager();
